import React from "react";
import {useTranslation} from "react-i18next";
import ARIcon from "../../components/ARIcon";
import ARTooltip from "../../components/ARTooltip";
import {CCard, CCardBody, CCardHeader} from "@coreui/react";
import RulesCard from "../../components/RulesComponents/RulesCard";
import {withErrorBoundary} from "../../components/ErrorBoundary";
import {ACTIONS, hasGlobalPermission} from "../../utils/user-access";
import {useDefaultRulesData} from "./hooks";
import {deleteRuleRequest, updateRuleRequest} from "../../services/api";
import "./Rules.scss";

const Rules = () => {
  const {t} = useTranslation();
  const {defaultRulesData: {rules, members, telegramChats}, updateDefaultRulesData} = useDefaultRulesData();

  return (
    <CCard className="Rules">
      <CCardHeader>
        <h1 className="card-header-text">
          {t("card.title.defaultRules", "Default rules")}
          <ARTooltip
            content={t("tooltip.defaultRules", "Default rules applied when no rules for the check")}
            placement="right"
          >
            <ARIcon className="Rules__tooltip-icon" name="cilInfo" size="lg" color="var(--secondary)"/>
          </ARTooltip>
        </h1>
      </CCardHeader>
      <CCardBody>
        <RulesCard
          rules={rules}
          members={members}
          telegramChats={telegramChats}
          noRulesText={t("noData.defaultRules")}
          updateStates={updateDefaultRulesData}
          updateRule={updateRuleRequest}
          deleteRule={deleteRuleRequest}
          showRuleAddButton={hasGlobalPermission(ACTIONS.CREATE_DEFAULT_RULES)}
          showRuleSwitcher={hasGlobalPermission(ACTIONS.ENABLE_DISABLE_DEFAULT_RULES)}
          showEditButton={hasGlobalPermission(ACTIONS.EDIT_DEFAULT_RULES)}
          showDeleteButton={hasGlobalPermission(ACTIONS.DELETE_DEFAULT_RULES)}
        />
      </CCardBody>
    </CCard>
  );
};

export default withErrorBoundary(Rules);